const DEFAULT_RETRIES = 5;
const DEFAULT_INTERVAL = 1000;

export function retry(
  fn: () => Promise<any>,
  retries = DEFAULT_RETRIES,
  interval = DEFAULT_INTERVAL,
  checkInterrupt?: () => boolean
) {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          const repeatContinuously = !!checkInterrupt;
          if (retries === 1 || (checkInterrupt && checkInterrupt())) {
            // reject('maximum retries exceeded');
            reject(error);

            return;
          }

          // Passing on "reject" is the important part
          retry(fn, retries - (repeatContinuously ? 0 : 1), interval, checkInterrupt).then(
            resolve,
            reject
          );
        }, interval);
      });
  });
}
